import { render } from "./ProductGroupForm.vue?vue&type=template&id=36906ff6&scoped=true"
import script from "./ProductGroupForm.vue?vue&type=script&lang=js"
export * from "./ProductGroupForm.vue?vue&type=script&lang=js"

import "./ProductGroupForm.vue?vue&type=style&index=0&id=36906ff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36906ff6"]])

export default __exports__